import { render, staticRenderFns } from "./camp-list.vue?vue&type=template&id=6820f4a8&scoped=true&"
import script from "./camp-list.vue?vue&type=script&lang=js&"
export * from "./camp-list.vue?vue&type=script&lang=js&"
import style0 from "./camp-list.vue?vue&type=style&index=0&id=6820f4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820f4a8",
  null
  
)

export default component.exports